import {useMemo, useState} from 'react';

export const useFormInputData = (params: {initialValue?: string; validator?: (value: string) => boolean}) => {
  const {initialValue = '', validator} = params;

  const [value, setInputDisplayName] = useState(initialValue);
  const isModified = value !== initialValue;
  const isValid = useMemo(() => (validator ? validator(value) : true), [validator, value]);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setInputDisplayName(e.target.value);
  const onReset = () => setInputDisplayName(initialValue);

  return {value, isModified, isValid, onChange, onReset};
};

export type UseFormInputDataValue = ReturnType<typeof useFormInputData>;
